import * as helpers from '../helpers';
import { isIdCorrect, prepareAccountNumber } from '../account-generator';
import validate from './validate';
import Swiper from 'swiper';
import axios from "axios";

// const taxPaymentSwiper = new Swiper('#tax-payment-v2-swiper', {
//   allowTouchMove: false,
//   autoHeight: true,
//   // calculateHeight: true,
//   speed: 500,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//     renderBullet: function (index, className) {
//       return '<span class="' + className + '">' + (index + 1) + '</span>';
//     },
//   },
//   navigation: {
//     nextEl: '.button-next',
//     prevEl: '.button-prev',
//   },
// })

const form = document.querySelector('.tax-payment-v2-form');
const peselLength = 11;
const nipLength = 10;

const addEventDataType = () => {
  if (!form) return false;

  const btns = form.querySelectorAll('button[data-type]');

  if (btns.length > 0) {
    btns.forEach(item => {
      item.addEventListener('click', e => onDataTypeChange(e));
    });
  }
}

const onDataTypeChange = ({ target }) => {
  const select = form.querySelector('.id-type select');
  if (!form || !select) return false;

  const type = target.getAttribute('data-type');
  resetDataTypeBtns();
  target.classList.add('btn-primary', 'active');
  helpers.resetErrors(form);

  if (typeof type !== 'undefined' && type) {
    const itemFieldsWrap = form.querySelector(`#${type}`);
    itemFieldsWrap.classList.remove('d-none');

    // Ukrywanie pola "Rodzaj identyfikatora"
    const idTypeGroup = form.querySelector('.id-type');
    if (idTypeGroup && type === 'person-data') idTypeGroup.classList.remove('d-none');
    else idTypeGroup.classList.add('d-none');

    if (type === 'person-data') select.value = 'pesel';
    else select.value = 'nip';
    // console.log('getType', select.value);

    setIdGroup();
    clearAccountField();
  }
}

export const getType = () => {
  const btn = form.querySelector('button[data-type].active');
  const select = form.querySelector('.id-type select');
  if (!btn || !select) return false;

  const personIdType = select.value;
  const type = btn.getAttribute('data-type');
  const typeId = type === 'person-data' ? (
    !personIdType ?
      1 : (
        personIdType === 'pesel' ?
          1 : 2
      )
  ) : 2;
  const label = typeId === 1 ? 'PESEL' : 'NIP';


  // console.log('getType', select.value);

  return { id: typeId, name: type, label };
}

const setIdGroup = (clear = true) => {
  const idDataGroup = form.querySelector('.id-data');
  if (!idDataGroup) return false;

  const type = getType();
  const label = idDataGroup.querySelector('label');
  const field = idDataGroup.querySelector('input');

  label.innerText = type.id === 2 ? 'NIP *' : 'PESEL *';
  field.name = type.id === 2 ? 'nip' : 'pesel';
  if (clear) field.value = '';

  if (type.id === 2) {
    field.setAttribute('maxlength', nipLength);
    field.setAttribute('placeholder', 'np. 7771112233 (bez myślników)');
  } else {
    field.setAttribute('maxlength', peselLength);
    field.setAttribute('placeholder', 'np. 79010123589');
  }
}

const clearAccountField = () => {
  const field = form.querySelector('[name="tax_account"]');
  if (!field) return false;

  field.value = '';
}

const resetDataTypeBtns = (activeItemKey = -1) => {
  if (!form) return false;

  const btnTypes = form.querySelectorAll('button[data-type]');

  btnTypes.forEach((item, key) => {
    const type = item.getAttribute('data-type');
    item.classList.remove('active');

    if (activeItemKey >= 0 && key === activeItemKey) item.classList.add('active');

    if (typeof type !== 'undefined' && type) {
      const itemFieldsWrap = form.querySelector(`#${type}`);

      if (typeof itemFieldsWrap !== 'undefined' && itemFieldsWrap) {
        const inputs = itemFieldsWrap.querySelectorAll('input');

        if (activeItemKey >= 0 && key === activeItemKey) itemFieldsWrap.classList.remove('d-none');
        else itemFieldsWrap.classList.add('d-none');

        if (inputs.length > 0) inputs.forEach(input => input.value = '');
      }
    }
  })
};

const addPaymentHash = (hash) => {
  if (!form || !hash) return false;

  const input = document.createElement('input');
  input.setAttribute('type', 'hidden');
  input.setAttribute('name', 'gph');
  input.value = hash;

  form.appendChild(input);
};

const getPaymentHash = (account) => {
  const form = new FormData();
  form.set('gph', account);

  axios({
    method: 'post',
    url: '/bm/',
    data: form,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
    .then((response) => {
      if (typeof response.data.gph !== 'undefined' && response.data.gph) {
        addPaymentHash(response.data.gph);
      }
    }).catch((error) => { });
};

const onPersonIdTypeChange = () => {
  setIdGroup();
  clearAccountField();
}

const addEventIdTypeChange = () => {
  if (!form) return false;

  const field = form.querySelector('.id-type select');
  field.addEventListener('change', e => onPersonIdTypeChange());
}

const addEventIdChange = () => {
  if (!form) return false;

  const field = form.querySelector('.id-data input');
  field.addEventListener('keyup', e => prepareAccount());
}

const prepareAccount = (showError = true) => {
  if (!form) return false;

  const field = form.querySelector('.id-data input');
  const type = getType();

  // helpers.resetErrors(form);

  // if (field.value != '' && isIdCorrect(type.id, field.value)) {
  //   const account = prepareAccountNumber(type.id, field.value);
  //   console.log('account', account);
  //   if (typeof account === 'undefined' || !account || account.isError) return false;
  //
  //   setAccountField(account.raw);
  // } else if (showError || (field.value != '' && !showError)) {
  //   helpers.error('Niepoprawny numer identyfikatora', type.label.toLowerCase());
  // }

  if (field.value != '' && validate(form, type.label.toLowerCase())) {
    const account = prepareAccountNumber(type.id, field.value);

    if (typeof account === 'undefined' || !account || account.isError) return false;

    getPaymentHash(account.raw);
    setAccountField(account.raw);
  }
}

const setAccountField = (accountNo) => {
  const field = form.querySelector('[name="tax_account"]');
  if (!field) return false;

  field.value = accountNo;
}

const onPeriodTypeChange = (target) => {
  const value = target.value;
  const field = form.querySelector('[name="period_no"]');
  if (!field) return false;

  const parentTarget = target.parentElement;
  const parentField = field.parentElement;

  if (value != 'R' && value != 0) {
    parentField.classList.remove('d-none');
    parentTarget.classList.remove('col-md-6');
    parentTarget.classList.add('col-md-4');
  } else {
    field.value = '';
    parentField.classList.add('d-none');
    parentTarget.classList.remove('col-md-4');
    parentTarget.classList.add('col-md-6');
  }
}

const onMountPeriodTypeCheck = () => {
  const field = form.querySelector('[name="period_type"]');
  if (!field) return false;

  onPeriodTypeChange(field);
}

const addEventSubmit = () => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    if (validate(e.target)) e.target.submit();
  });
}

// const addEventAmountChange = () => {
//   if (!form) return false;
//
//   const field = form.querySelector('.amount-data input');
//   field.addEventListener('keyup', e => prepareAccount(e));
// }

const addCommission = (amount) => {
  const element = form.querySelector('#commission');
  if (!element) return false;

  if (/^[\d\,\.]+$/.test(amount.value) && (parseFloat(amount.value.replace(',', '.')) < parseFloat('4300.00'))) {

    const preparedAmount = parseFloat(amount.value.replace(',', '.'));
    const commission = parseFloat(Math.ceil(preparedAmount / 1000));
    element.innerHTML = commission.toFixed(2);
  } else {
    element.innerHTML = '0,00';
  }
}

const addEventAllFields = () => {
  const allFields = form.querySelectorAll('input, select');

  allFields.forEach(item => {
    item.addEventListener('input', (e) => {
      // console.log('EVENT ALL', e.target.name, e.target);
      const { target } = e;
      if (typeof target.name === 'undefined' || !target.name) return false;

      if (target.name == 'period_type') onPeriodTypeChange(target);
      if (target.name == 'tax_amount') addCommission(target);
      validate(form, target.name);
    })
  })
}

const init = () => {
  if (!form) return false;
  addEventDataType();
  addEventIdChange();
  // addEventAmountChange();
  setIdGroup(false);
  prepareAccount(false);
  addEventSubmit();
  addEventAllFields();
  onMountPeriodTypeCheck();
  addEventIdTypeChange();
}

export default init();